import {
  useEffect,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  getCryptoBalance,
  usersSelectors
} from 'store'
import {
  Image,
  Skeleton,
  Stack,
  Text
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'
import { PENDING } from 'utils/constants'

export const CoinList = ({
  id,
  setCloseText
}) => {
  const dispatch = useDispatch()
  const {
    cryptoBalance,
    getCryptoBalanceStatus
  } = useSelector(usersSelectors)
  const [longPressedCrypto, setLongPressedCrypto] = useState('')
  const loopThis = cryptoBalance.length ? cryptoBalance : Array.from({ length: 2 })

  const handlePress = () => {
    setCloseText('Information Only. Long Press to refresh.')
    setTimeout(() => setCloseText('Close'), 2000)
  }

  const handleLongPress = (cb) => {
    if (
      getCryptoBalanceStatus !== PENDING
      && longPressedCrypto === ''
    ) {
      setLongPressedCrypto(cb?.ticker)
      dispatch(getCryptoBalance(id))
    }
  }

  useEffect(() => {
    if (
      getCryptoBalanceStatus !== PENDING
      && longPressedCrypto !== ''
    ) {
      setLongPressedCrypto('')
    }
  }, [getCryptoBalanceStatus])

  return loopThis.map((cb, i) => {
    let pressTimer = null

    const handlePressStart = () => {
      pressTimer = setTimeout(() => {
        handleLongPress(cb)
        pressTimer = null
      }, 600)
    }

    const handlePressEnd = () => {
      if (pressTimer) {
        clearTimeout(pressTimer)
        pressTimer = null
        handlePress()
      }
    }

    return (
      <Stack
        as="button"
        height="50px"
        margin="20px auto"
        width="100%"
        border="solid 1px black"
        borderRadius="5px"
        alignItems="center"
        transition="0.8s ease"
        overflow="hidden"
        padding="0px"
        gap="0px"
        position="absolute"
        top={i === 0 ? '228px' : `${(61 * i) + 230}px`}
        boxShadow="0 4px 3px rgba(0, 0, 0, 0.1) !important"
        onMouseDown={() => {
          if (cryptoBalance.length) {
            handlePressStart()
          }
        }}
        onMouseUp={() => {
          if (cryptoBalance.length) {
            handlePressEnd()
          }
        }}
        onTouchStart={() => {
          if (cryptoBalance.length) {
            handlePressStart()
          }
        }}
        onTouchEnd={() => {
          if (cryptoBalance.length) {
            handlePressEnd()
          }
        }}
      >
        <Skeleton
          isLoaded={cryptoBalance.length && longPressedCrypto !== cb?.ticker}
          width="100%"
          height="100%"
          borderRadius="5px"
          padding="0px"
        >
          <Image
            boxSize="20px"
            objectFit="cover"
            src={cb?.ticker === 'CNCTR' ? ImagesPng.CnctrSymbol : ImagesPng.PolSymbol}
            alt="cnctr-symbol"
            borderRadius="full"
            height="80%"
            width="auto"
            margin="4px 0px 4px 10px"
            boxShadow="0 3px 10px rgba(0, 0, 0, 0.4) !important"
          />

          <Text
            textAlign="center"
            maxWidth="240px"
            position="absolute"
            top="2px"
            left="60px"
            letterSpacing="-0.5px"
          >
            {`${cb?.name} (${cb?.ticker})`}
          </Text>

          <Text
            textAlign="center"
            maxWidth="240px"
            position="absolute"
            top="20px"
            left="60px"
            letterSpacing="-0.5px"
          >
            {cb?.price}
          </Text>

          <Text
            textAlign="center"
            maxWidth="240px"
            position="absolute"
            top="2px"
            right="10px"
            letterSpacing="-0.5px"
          >
            {new Intl.NumberFormat().format(cb?.balance)}
          </Text>

          <Text
            textAlign="center"
            maxWidth="240px"
            position="absolute"
            top="20px"
            right="10px"
            letterSpacing="-0.5px"
          >
            {`$${new Intl.NumberFormat().format(cb?.price * cb?.balance)}`}
          </Text>
        </Skeleton>
      </Stack>
    )
  })
}
